// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"e67ca960","760":"7f7ef283","824":"3f79377b"}[chunkId] + ".chunk.css";
};